import $ from 'jquery'

function initAccordion() {
  const accordionId = $(`.sui-accordion`).attr('id')
  const accordionTitles = $(`.sui-accordion .sui-accordion-title`)

  accordionTitles.each(function (index) {
    const wrapperClass = 'sui-accordion-item-wrapper'
    const isInitialized = $(this).parent().hasClass(wrapperClass)
    if (isInitialized) {
      return
    }
    $(this).next().addBack().wrapAll(`<div class='${wrapperClass}' />`)

    $(this)
      .attr('id', `heading${index}`)
      .wrapInner(
        `<a class="h4 collapsed" data-cy="accordion-item-title" data-toggle="collapse" data-target="#collapse${index}" aria-expanded="true" aria-controls="collapse${index}"></a>`,
      )
      .next(`.sui-accordion-item`)
      .wrap(
        `<div id="collapse${index}" class="collapse" data-cy="accordion-item-content" aria-labelledby="heading${index}" data-parent="#${accordionId}">`,
      )

    let icon = '<i class="fa-light fa-plus"></i>'
    if ($(this).next().find(`.sui-accordion-item`).hasClass('show')) {
      $(this).next().addClass('show')
      icon = '<i class="fa-light fa-minus"></i>'
    }

    $('a', this).append(icon)

    $(`.sui-accordion`).show()
  })
}

const addAccordion = () => {
  initAccordion()

  $('.collapse')
    .on('show.bs.collapse', function () {
      $(this).parent().find('.fa-plus').removeClass('fa-plus').addClass('fa-minus')
    })
    .on('hide.bs.collapse', function () {
      $(this).parent().find('.fa-minus').removeClass('fa-minus').addClass('fa-plus')
    })
}

document.addEventListener('DOMContentLoaded', () => addAccordion())
